import styled from "styled-components";

const ProfilePanelLabel = styled.div`
  width: 75px;
  text-align: left;
  flex-shrink: 0;
`;

export default ProfilePanelLabel;
